import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

export const getModalPropertyLeadImageSrc = (property: IPropertyDetailDTO) => {
    const offerFirstThumbnails = property.offer.images[0]?.thumbnails;

    return (
        property.images[0]?.thumbnails.g_img_155x87 ?? offerFirstThumbnails?.g_img_155x87 ?? offerFirstThumbnails?.g_img_500 ?? offerFirstThumbnails?.g_img_750
    );
};
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

export const getModalPropertyLeadImageSrc = (property: IPropertyDetailDTO) => {
    const offerFirstThumbnails = property.offer.images[0]?.thumbnails;

    return (
        property.images[0]?.thumbnails.g_img_155x87 ?? offerFirstThumbnails?.g_img_155x87 ?? offerFirstThumbnails?.g_img_500 ?? offerFirstThumbnails?.g_img_750
    );
};
